<template>
  <div class="share-users-with-access">
    <div
      v-for="user in usersWithAccess"
      :key="user.user_ulid"
      class="d-flex align-center justify-space-between w-100 mb-4 share-user"
    >
      <div class="d-flex flex-column">
        <span class="hiring-name">
          {{ user.first_name }} {{ user.last_name }}
        </span>
        <span class="hiring-role-type">
          {{ user.role_type || '' }}
        </span>
      </div>
      <p
        v-if="user.type_key === TYPE_ACTIVE"
        class="hiring-link"
        @click="$emit('select-user', user)"
      >
        Email report link
      </p>
      <DpplNewButton
        v-else
        variant="outlined"
        color="brandPrimary"
        size="small"
        @click="$emit('select-user', user)"
      >
        Invite to datapeople
      </DpplNewButton>
    </div>
  </div>
</template>

<script setup>
import { TYPE_ACTIVE } from '@/helpers/constants/userType';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

defineProps({
  usersWithAccess: {
    type: Array,
    required: true,
  },
});

defineEmits(['select-user']);
</script>

<style lang="less" scoped>
.share-users-with-access {
  max-height: 162px;
  overflow-y: auto;
  border-bottom: 1px solid @stroke-default;
  width: calc(100% + 48px);
  transform: translateX(-24px);
}

.share-user {
  padding: 0 24px;
}

.hiring-name {
  max-width: 200px;
  word-break: break-word;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  color: @text-darkest;
}

.hiring-role-type {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  color: @text-light;
}

.hiring-link {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  color: @text-brand;
  cursor: pointer;
}
</style>
